import { FeaturePageCitations } from "@/features/feature-page/feature-page-citations";
import { FeaturePageSection } from "@/features/feature-page/feature-page-section";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";

export function PullQuoteBlock({
  block,
}: {
  block: Extract<ResolvedFeaturePageBlock, { type: "pullQuote" }>;
}) {
  return (
    <FeaturePageSection block={block} resolvedBackground={block.resolvedBackground}>
      {block.heading ? (
        <h2
          id={`${block.id}-heading`}
          className="mb-8 text-center text-3xl font-bold tracking-tight sm:text-5xl"
        >
          {block.heading}
        </h2>
      ) : null}
      <blockquote className="mx-auto max-w-5xl text-center">
        <p className="text-balance text-3xl font-bold leading-tight sm:text-5xl">“{block.quote}”</p>
        <footer className="mt-6 text-sm font-semibold text-muted-foreground">
          <cite className="not-italic">{block.attribution}</cite>
          {block.context ? ` — ${block.context}` : ""}
          <FeaturePageCitations sourceIds={block.sourceId ? [block.sourceId] : undefined} />
        </footer>
      </blockquote>
    </FeaturePageSection>
  );
}
